import { render, staticRenderFns } from "./STruck.vue?vue&type=template&id=56b779b4"
import script from "./STruck.vue?vue&type=script&lang=js"
export * from "./STruck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports